const fr = {
  auth: {
    loginTab: "Connexion",
    registerTab: "Créer un compte",
    email: "E-mail",
    password: "Mot de passe",
    passwordHint: "8 caractères minimum",
    name: "Nom et prénom",
    role: "Je suis",
    roles: { client: "Entreprise cliente (usine, site)", expert: "Expert / technicien" },
    login: "Se connecter",
    register: "Créer mon compte",
    google: "Continuer avec Google",
    or: "ou",
    invalid: "E-mail ou mot de passe incorrect.",
    exists: "Un compte existe déjà pour cet e-mail.",
    locked: "Trop de tentatives. Réessayez dans 15 minutes.",
    googleFailed: "La connexion Google a échoué. Veuillez réessayer.",
    pickRoleTitle: "Choisissez votre profil",
    pickRoleDesc: "Ce choix détermine votre espace : dossier entreprise ou dossier expert. Il ne pourra plus être modifié.",
    confirmRole: "Valider",
    logout: "Déconnexion",
    mySpace: "Mon espace",
    signIn: "Connexion",
    gateTitle: { client: "Espace client sécurisé", expert: "Espace expert sécurisé", timer: "Horodateur sécurisé" },
    gateDesc: {
      client: "Connectez-vous avec votre compte entreprise pour gérer votre profil, suivre vos demandes, vos interventions et télécharger vos factures.",
      expert: "Connectez-vous avec votre compte expert pour gérer votre profil, rejoindre le pool interrogé par le moteur de correspondance et suivre vos missions.",
      timer: "L'horodateur est réservé aux experts : démarrez et terminez les interventions qui vous sont assignées. Les clients y retrouvent leurs interventions et factures.",
    },
    wrongRole: { client: "Cet onglet est réservé aux comptes entreprise.", expert: "Cet onglet est réservé aux comptes expert." },
    adminHere: "Vous êtes connecté en administrateur.",
    openAdmin: "Ouvrir la console d'administration",
    openSpace: "Ouvrir mon espace complet",
    signedAs: "Connecté :",
  },
  dossier: {
    eyebrow: "Espace pro",
    tabs: { dossier: "Mon dossier", model: "Modèle économique" },
    clientTitle: "Dossier entreprise",
    expertTitle: "Dossier expert",
    profile: "Profil",
    noProfileExpert: "Complétez votre profil pour rejoindre le pool d'experts.",
    noProfileClient: "Complétez le profil de votre entreprise.",
    phone: "Téléphone WhatsApp (format international)",
    phonePh: "+225 07 00 00 00 00",
    optin: "J'accepte de recevoir les notifications d'intervention par WhatsApp",
    phoneIntl: "Format international requis, ex. +225 07 00 00 00 00.",
    optinNeedsPhone: "Indiquez un numéro pour activer WhatsApp.",
    saveProfile: "Enregistrer le profil",
    saved: "Profil enregistré.",
    requests: "Mes demandes de diagnostic",
    newRequest: "Nouvelle demande",
    interventions: "Mes interventions",
    assignedExpert: "Expert assigné",
    pending: "En attente d'assignation",
    myMissions: "Missions assignées",
    noMissions: "Aucune intervention ne vous est assignée pour le moment. L'équipe IndusHub vous assigne les demandes correspondant à votre profil.",
    start: "Démarrer",
    stop: "Terminer et facturer",
    client: "Client",
    request: "Demande",
    invoice: "Facture PDF",
    linked: "Les enregistrements existants associés à votre e-mail ont été rattachés à votre compte.",
    statusIv: { assigned: "Assignée", running: "En cours", completed: "Facturée" },
    timerRunning: "Chronomètre en cours",
    emailLocked: "E-mail du compte (non modifiable)",
  },
  matchingX: { request: "Demander cet expert", preferred: "Expert souhaité", clear: "Retirer", loginForRate: "Connectez-vous pour voir le tarif" },
  contactInfo: {
    label: "Pour toute autre demande, contactez-nous :",
    adminTitle: "Coordonnées de contact (site public)",
    phone: "Téléphone",
    email: "E-mail",
    save: "Enregistrer les coordonnées",
    whatsapp: "WhatsApp (bouton flottant)",
    whatsappHint: "Format international, ex. +33 6 95 60 81 21. Laissez vide pour masquer le bouton.",
  },
  traffic: {
    tab: "Fréquentation",
    title: "Fréquentation du site public",
    today: "Aujourd'hui", d7: "7 derniers jours", d30: "30 derniers jours",
    visits: "visites", uniques: "visiteurs uniques",
    live: "visiteur(s) ces 5 dernières minutes",
    daily: "Visites par jour (30 jours)",
    topPages: "Pages les plus vues", topReferrers: "Sites référents", devices: "Appareils", languages: "Langues", countries: "Pays",
    deviceNames: { desktop: "Ordinateur", mobile: "Mobile", tablet: "Tablette" },
    none: "Pas encore de données.",
    privacy: "Mesure d'audience interne et anonyme : sans cookie, adresses IP non stockées (empreinte hachée renouvelée chaque jour), robots et pages d'administration exclus. Données conservées 400 jours.",
  },
  account: {
    title: "Sécurité du compte",
    changePassword: "Changer mon mot de passe",
    current: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe (8 caractères min.)",
    confirm: "Confirmer le nouveau mot de passe",
    savePassword: "Mettre à jour le mot de passe",
    passwordDone: "Mot de passe mis à jour. Vos autres sessions ont été déconnectées.",
    wrongCurrent: "Mot de passe actuel incorrect.",
    googleOnly: "Votre compte utilise la connexion Google : aucun mot de passe à modifier.",
    changeEmail: "Changer l'e-mail administrateur",
    newEmail: "Nouvel e-mail",
    saveEmail: "Mettre à jour l'e-mail",
    emailDone: "E-mail mis à jour. Vos autres sessions ont été déconnectées.",
    emailTaken: "Un compte existe déjà pour cet e-mail.",
  },
  cleanup: {
    deleteExamples: "Supprimer tous les experts d'exemple",
    confirmExamples: (n) => `Supprimer définitivement les ${n} expert(s) d'exemple ? Ils ne seront pas recréés au redémarrage.`,
    examplesDone: (n) => `${n} expert(s) d'exemple supprimé(s).`,
    noExamples: "Aucun expert d'exemple.",
    title: "Données de test",
    desc: "Supprime les comptes de test (expert.test, client.test, comptes @example.com), leurs demandes, interventions, ainsi que les partenaires, chiffres clés et numéro WhatsApp créés pendant les tests. Le compte administrateur est conservé. Les comptes de test ne sont pas recréés au redémarrage.",
    preview: "À supprimer",
    purge: "Supprimer les données de test",
    confirmPurge: "Confirmer la suppression définitive des données de test listées ?",
    purgeDone: "Données de test supprimées.",
    nothing: "Aucune donnée de test détectée.",
    labels: { accounts: "Comptes", experts: "Experts", clients: "Clients", diagnostics: "Demandes", interventions: "Interventions", academy_requests: "Demandes de session (Académie)", partners: "Partenaires", custom_figures: "Chiffres clés personnalisés", test_admin_whatsapp: "Numéro WhatsApp de test" },
    yes: "oui", no: "non",
  },
  reset: {
    forgot: "Mot de passe oublié ?",
    titleRequest: "Mot de passe oublié",
    titleNew: "Nouveau mot de passe",
    requestDesc: "Indiquez l'e-mail de votre compte. Si un compte existe, vous recevrez un lien pour choisir un nouveau mot de passe (valable 1 heure).",
    send: "Envoyer le lien",
    sent: "Si un compte existe pour cet e-mail, un message vient d'être envoyé. Pensez à vérifier vos courriers indésirables.",
    tooMany: "Trop de demandes. Réessayez plus tard.",
    newPassword: "Nouveau mot de passe",
    confirm: "Confirmer le mot de passe",
    save: "Enregistrer le mot de passe",
    done: "Mot de passe mis à jour. Toutes vos sessions précédentes ont été déconnectées — connectez-vous avec votre nouveau mot de passe.",
    invalid: "Ce lien est invalide, expiré ou déjà utilisé. Faites une nouvelle demande.",
    back: "Retour à la connexion",
  },
  contactX: {
    optin: "Recevoir le suivi de ma demande par WhatsApp",
    phoneIntl: "Pour WhatsApp, utilisez le format international (+225…).",
  },
  verified: {
    label: "Expert vérifié IndusHub",
    since: (d) => `Vérifié depuis ${d}`,
    tip: "Profil examiné et approuvé par l'équipe IndusHub (identité, compétences et expérience).",
  },
  alerts: {
    title: "Alerte nouvel expert en attente",
    desc: "E-mail immédiat au destinataire du rapport dès qu'un profil expert passe « en attente » (inscription ou nouvelle soumission après refus). Une seule alerte par expert et par heure.",
    toggle: "Alerte activée",
    statusLabel: "Alerte admin :",
    status: { sent: "envoyée", failed: "échec", skipped_dedupe: "ignorée (déjà envoyée < 1h)", skipped_disabled: "désactivée", skipped_no_recipient: "aucun destinataire" },
  },
  reportRun: {
    attempts: (n) => `${n} tentative(s)`,
    lastError: "Dernière erreur :",
    nextRetry: "Prochaine tentative :",
    notice: "Avis d'échec envoyé :",
  },
  academy: {
    eyebrow: "Académie IndusHub",
    title: "Former vos équipes aux standards internationaux",
    desc: "Des modules conçus par nos experts pour chaque secteur, délivrés sur site, à distance ou en format hybride, et adaptés au niveau de vos équipes.",
    all: "Tous les secteurs",
    filterLabel: "Filtrer les modules par secteur",
    catalogLink: "Voir le catalogue de l'Académie",
    objectives: "Objectifs",
    audience: "Public",
    duration: "Durée",
    format: "Format",
    level: "Niveau",
    standard: "Norme",
    formats: { onsite: "Sur site", remote: "À distance", hybrid: "Hybride" },
    levels: { beginner: "Initiation", intermediate: "Intermédiaire", advanced: "Avancé" },
    request: "Demander une session",
    none: "Aucun module publié pour ce secteur pour le moment.",
    quoteNote: "Programme, dates et devis confirmés sous 48h après votre demande.",
    form: {
      title: "Demander une session",
      company: "Entreprise",
      contact: "Nom du contact",
      email: "E-mail professionnel",
      phone: "Téléphone",
      site: "Pays / site",
      participants: "Nombre de participants",
      dates: "Dates souhaitées",
      datesPh: "ex. semaine du 12 janvier, ou T1 2027",
      format: "Format souhaité",
      message: "Message (facultatif)",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      success: (ref) => `Demande ${ref} envoyée. Un e-mail de confirmation vient de vous être adressé ; l'équipe Académie vous recontacte sous 48h.`,
      participantsErr: "Entre 1 et 500 participants.",
      tooMany: "Trop de demandes envoyées. Réessayez dans une heure.",
      prefilled: "Formulaire prérempli avec votre profil entreprise.",
      close: "Fermer",
    },
    mine: "Mes demandes de session (Académie)",
    mineEmpty: "Aucune demande de session pour l'instant.",
    statuses: { new: "Nouvelle", in_progress: "En cours", scheduled: "Planifiée", done: "Terminée", cancelled: "Annulée" },
    h: { ref: "Réf.", date: "Date", module: "Module", participants: "Participants", dates: "Dates souhaitées", format: "Format", status: "Statut", company: "Entreprise", contact: "Contact", emails: "E-mails" },
    admin: {
      tab: "Académie",
      modules: "Modules du catalogue",
      requests: "Demandes de session",
      add: "Nouveau module",
      edit: "Modifier",
      save: "Enregistrer le module",
      cancel: "Annuler",
      del: "Supprimer",
      confirmDel: (n) => `Supprimer le module « ${n} » ? Une sauvegarde de sécurité est créée avant la suppression.`,
      published: "Publié",
      up: "Monter",
      down: "Descendre",
      vertical: "Secteur",
      titleFr: "Titre FR", titleEn: "Titre EN", descFr: "Description FR", descEn: "Description EN",
      objFr: "Objectifs FR (un par ligne)", objEn: "Objectifs EN (un par ligne)",
      audFr: "Public FR", audEn: "Public EN", durFr: "Durée FR", durEn: "Durée EN",
      saved: "Module enregistré.",
      empty: "Aucun module.",
      requestsEmpty: "Aucune demande de session.",
      csv: "Exporter les demandes (CSV)",
    },
  },
  matchFilter: {
    label: "Experts vérifiés uniquement",
    hidden: (n) => `${n} résultat(s) non vérifié(s) masqué(s)`,
    show: "Afficher",
  },
  backup: {
    tab: "Sauvegarde",
    title: "Sauvegarde des données",
    desc: "Les mises à jour et redéploiements ne suppriment jamais vos données : le démarrage n'efface rien, les données initiales ne sont créées qu'une seule fois et les évolutions de structure ne font qu'ajouter des champs. En complément, exportez vos données à tout moment.",
    exportAll: "Exporter tout (ZIP JSON)",
    csvClients: "Clients (CSV)",
    csvExperts: "Experts (CSV)",
    createNow: "Créer une sauvegarde maintenant",
    created: "Sauvegarde créée.",
    failed: "La sauvegarde a échoué.",
    storedTitle: "Sauvegardes stockées",
    storedDesc: "Une sauvegarde automatique est créée chaque semaine (8 dernières conservées). Une sauvegarde de sécurité est aussi créée avant chaque suppression (expert, experts d'exemple, données de test).",
    none: "Aucune sauvegarde stockée pour l'instant — la première sauvegarde hebdomadaire est créée automatiquement quelques minutes après le démarrage.",
    h: { date: "Date", kind: "Type", size: "Taille", content: "Contenu", where: "Stockage", dl: "Télécharger" },
    kinds: { weekly: "Hebdomadaire", manual: "Manuelle", "pre-delete": "Avant suppression" },
    where: { object: "Stockage objet", db: "Base de données" },
    docs: "documents",
    download: "Télécharger",
  },
  approval: {
    h: "Statut",
    status: { pending: "En attente", approved: "Approuvé", rejected: "Refusé" },
    all: "Tous",
    filterLabel: "Filtrer les experts par statut",
    approve: "Approuver",
    reject: "Refuser",
    reasonPrompt: (n) => `Motif du refus pour ${n} (facultatif, communiqué à l'expert par e-mail) :`,
    pendingLower: "en attente",
    badge: (n) => `${n} profil(s) en attente de validation`,
    reason: "Motif :",
    desc: {
      pending: "Votre profil est en cours de validation par l'équipe IndusHub. Il n'apparaît pas encore dans les résultats de correspondance.",
      approved: "Votre profil est validé : il apparaît dans les résultats de correspondance et vous pouvez recevoir des missions.",
      rejected: "Votre profil n'a pas été retenu. Mettez-le à jour et enregistrez-le pour le soumettre de nouveau à validation.",
    },
  },
  report: {
    title: "Rapport hebdomadaire par e-mail",
    desc: "Envoyé chaque lundi à 8h (heure de Paris) : visites et visiteurs uniques (vs semaine précédente), top 3 des pages, nouvelles demandes, nouveaux experts, interventions terminées et total facturé HT.",
    enabled: "Envoi automatique activé",
    recipient: "Destinataire",
    save: "Enregistrer",
    preview: "Envoyer un aperçu maintenant",
    previewNote: "L'aperçu couvre les 7 derniers jours et part vers le destinataire enregistré.",
    previewSent: (e) => `Aperçu envoyé à ${e}.`,
    previewFailed: "L'envoi de l'aperçu a échoué.",
    last: "Dernier envoi automatique :",
    never: "Aucun envoi automatique pour l'instant.",
    runStatus: { sent: "envoyé", failed: "échec", sending: "en cours", retrying: "nouvelle tentative prévue", abandoned: "abandonné", cancelled: "annulé" },
  },
  waFab: {
    label: (n) => `Nous écrire sur WhatsApp (${n})`,
    message: "Bonjour IndusHub Afrique, je souhaite obtenir des informations sur vos services.",
  },
  adminX: {
    tabs: { partners: "Partenaires", settings: "Contenus & réglages", whatsapp: "Journal WhatsApp" },
    assign: "Assigner un expert",
    assignPh: "Choisir un expert…",
    reassign: "Réassigner",
    preferred: "souhaité",
    confirmation: "Accusé client",
    emailStatus: { pending: "en attente", sent: "envoyé", failed: "échec", skipped_no_recipient: "ignoré", skipped_rate_limited: "limité" },
    waOn: "WhatsApp Brevo configuré.",
    waOff: (m) => `WhatsApp Brevo incomplet (manquant : ${m}) — les envois sont ignorés et journalisés « skipped ».`,
    partnerName: "Nom",
    partnerLink: "Lien (https://…)",
    partnerOrder: "Ordre",
    partnerLogo: "Logo (PNG, JPG, WEBP, SVG — 2 Mo max)",
    addPartner: "Ajouter le partenaire",
    save: "Enregistrer",
    upload: "Téléverser le logo",
    uploading: "Téléversement…",
    noLogo: "Sans logo",
    partnersEmpty: "Aucun partenaire : la page d'accueil affiche les emplacements élégants par défaut.",
    confirmDelPartner: (n) => `Supprimer le partenaire ${n} ?`,
    figuresTitle: "Chiffres clés (page d'accueil)",
    figuresDesc: "Laissez vide pour conserver les chiffres par défaut. « Compteur en direct » affiche le nombre d'experts en base.",
    valueFr: "Valeur FR", valueEn: "Valeur EN", labelFr: "Libellé FR", labelEn: "Libellé EN", live: "Compteur en direct",
    addFigure: "Ajouter un chiffre",
    remove: "Retirer",
    saveFigures: "Enregistrer les chiffres",
    resetFigures: "Revenir aux valeurs par défaut",
    notifTitle: "Notifications WhatsApp administrateur",
    adminWa: "Numéro WhatsApp admin (format international)",
    saveNotif: "Enregistrer le numéro",
    waH: { date: "Date", event: "Événement", ref: "Réf.", role: "Destinataire", number: "Numéro", status: "Statut", detail: "Détail" },
    events: { urgent_request: "Demande urgente", intervention_assigned: "Assignation", intervention_started: "Démarrage", intervention_finished: "Clôture" },
    roles: { client: "Client", expert: "Expert", admin: "Admin" },
    waStatus: { sent: "envoyé", failed: "échec", skipped: "ignoré" },
  },
};

const en = {
  auth: {
    loginTab: "Sign in",
    registerTab: "Create account",
    email: "E-mail",
    password: "Password",
    passwordHint: "At least 8 characters",
    name: "Full name",
    role: "I am",
    roles: { client: "Client company (plant, site)", expert: "Expert / technician" },
    login: "Sign in",
    register: "Create my account",
    google: "Continue with Google",
    or: "or",
    invalid: "Incorrect e-mail or password.",
    exists: "An account already exists for this e-mail.",
    locked: "Too many attempts. Try again in 15 minutes.",
    googleFailed: "Google sign-in failed. Please try again.",
    pickRoleTitle: "Choose your profile",
    pickRoleDesc: "This choice sets your space: company file or expert file. It cannot be changed later.",
    confirmRole: "Confirm",
    logout: "Sign out",
    mySpace: "My space",
    signIn: "Sign in",
    gateTitle: { client: "Secure client space", expert: "Secure expert space", timer: "Secure timer" },
    gateDesc: {
      client: "Sign in with your company account to manage your profile, track your requests and interventions, and download your invoices.",
      expert: "Sign in with your expert account to manage your profile, join the pool queried by the matching engine and track your missions.",
      timer: "The timer is reserved for experts: start and end the interventions assigned to you. Clients find their interventions and invoices here.",
    },
    wrongRole: { client: "This tab is reserved for company accounts.", expert: "This tab is reserved for expert accounts." },
    adminHere: "You are signed in as administrator.",
    openAdmin: "Open the admin console",
    openSpace: "Open my full space",
    signedAs: "Signed in:",
  },
  dossier: {
    eyebrow: "Pro space",
    tabs: { dossier: "My file", model: "Business model" },
    clientTitle: "Company file",
    expertTitle: "Expert file",
    profile: "Profile",
    noProfileExpert: "Complete your profile to join the expert pool.",
    noProfileClient: "Complete your company profile.",
    phone: "WhatsApp phone (international format)",
    phonePh: "+225 07 00 00 00 00",
    optin: "I agree to receive intervention notifications via WhatsApp",
    phoneIntl: "International format required, e.g. +225 07 00 00 00 00.",
    optinNeedsPhone: "Enter a number to enable WhatsApp.",
    saveProfile: "Save profile",
    saved: "Profile saved.",
    requests: "My diagnostic requests",
    newRequest: "New request",
    interventions: "My interventions",
    assignedExpert: "Assigned expert",
    pending: "Awaiting assignment",
    myMissions: "Assigned missions",
    noMissions: "No intervention is assigned to you yet. The IndusHub team assigns you requests matching your profile.",
    start: "Start",
    stop: "End and invoice",
    client: "Client",
    request: "Request",
    invoice: "PDF invoice",
    linked: "Existing records linked to your e-mail have been attached to your account.",
    statusIv: { assigned: "Assigned", running: "Running", completed: "Invoiced" },
    timerRunning: "Timer running",
    emailLocked: "Account e-mail (read-only)",
  },
  matchingX: { request: "Request this expert", preferred: "Preferred expert", clear: "Remove", loginForRate: "Log in to see rate" },
  contactInfo: {
    label: "For any other request, contact us:",
    adminTitle: "Contact details (public site)",
    phone: "Phone",
    email: "E-mail",
    save: "Save contact details",
    whatsapp: "WhatsApp (floating button)",
    whatsappHint: "International format, e.g. +33 6 95 60 81 21. Leave empty to hide the button.",
  },
  traffic: {
    tab: "Traffic",
    title: "Public site traffic",
    today: "Today", d7: "Last 7 days", d30: "Last 30 days",
    visits: "visits", uniques: "unique visitors",
    live: "visitor(s) in the last 5 minutes",
    daily: "Visits per day (30 days)",
    topPages: "Top pages", topReferrers: "Referrers", devices: "Devices", languages: "Languages", countries: "Countries",
    deviceNames: { desktop: "Desktop", mobile: "Mobile", tablet: "Tablet" },
    none: "No data yet.",
    privacy: "Internal, anonymous audience measurement: no cookies, IP addresses not stored (hashed fingerprint renewed daily), bots and admin pages excluded. Data kept for 400 days.",
  },
  account: {
    title: "Account security",
    changePassword: "Change my password",
    current: "Current password",
    newPassword: "New password (min. 8 characters)",
    confirm: "Confirm new password",
    savePassword: "Update password",
    passwordDone: "Password updated. Your other sessions have been signed out.",
    wrongCurrent: "Current password is incorrect.",
    googleOnly: "Your account uses Google sign-in: there is no password to change.",
    changeEmail: "Change admin e-mail",
    newEmail: "New e-mail",
    saveEmail: "Update e-mail",
    emailDone: "E-mail updated. Your other sessions have been signed out.",
    emailTaken: "An account already exists for this e-mail.",
  },
  cleanup: {
    deleteExamples: "Delete all example experts",
    confirmExamples: (n) => `Permanently delete the ${n} example expert(s)? They will not be re-created on restart.`,
    examplesDone: (n) => `${n} example expert(s) deleted.`,
    noExamples: "No example experts.",
    title: "Test data",
    desc: "Deletes test accounts (expert.test, client.test, @example.com accounts), their requests and interventions, plus partners, key figures and WhatsApp number created during testing. The admin account is kept. Test accounts are not re-created on restart.",
    preview: "To be deleted",
    purge: "Delete test data",
    confirmPurge: "Confirm permanent deletion of the listed test data?",
    purgeDone: "Test data deleted.",
    nothing: "No test data detected.",
    labels: { accounts: "Accounts", experts: "Experts", clients: "Clients", diagnostics: "Requests", interventions: "Interventions", academy_requests: "Session requests (Academy)", partners: "Partners", custom_figures: "Custom key figures", test_admin_whatsapp: "Test WhatsApp number" },
    yes: "yes", no: "no",
  },
  reset: {
    forgot: "Forgot password?",
    titleRequest: "Forgot password",
    titleNew: "New password",
    requestDesc: "Enter your account e-mail. If an account exists, you will receive a link to choose a new password (valid for 1 hour).",
    send: "Send link",
    sent: "If an account exists for this e-mail, a message has just been sent. Remember to check your spam folder.",
    tooMany: "Too many requests. Try again later.",
    newPassword: "New password",
    confirm: "Confirm password",
    save: "Save password",
    done: "Password updated. All your previous sessions have been signed out — sign in with your new password.",
    invalid: "This link is invalid, expired or already used. Please make a new request.",
    back: "Back to sign in",
  },
  contactX: {
    optin: "Receive updates on my request via WhatsApp",
    phoneIntl: "For WhatsApp, use international format (+225…).",
  },
  verified: {
    label: "Verified IndusHub expert",
    since: (d) => `Verified since ${d}`,
    tip: "Profile reviewed and approved by the IndusHub team (identity, skills and experience).",
  },
  alerts: {
    title: "New pending expert alert",
    desc: "Instant e-mail to the report recipient whenever an expert profile becomes “pending” (signup or resubmission after rejection). One alert per expert per hour.",
    toggle: "Alert enabled",
    statusLabel: "Admin alert:",
    status: { sent: "sent", failed: "failed", skipped_dedupe: "skipped (already sent < 1h)", skipped_disabled: "disabled", skipped_no_recipient: "no recipient" },
  },
  reportRun: {
    attempts: (n) => `${n} attempt(s)`,
    lastError: "Last error:",
    nextRetry: "Next retry:",
    notice: "Failure notice sent:",
  },
  academy: {
    eyebrow: "IndusHub Academy",
    title: "Train your teams to international standards",
    desc: "Modules designed by our experts for each sector, delivered on site, remotely or hybrid, and tailored to your teams' level.",
    all: "All sectors",
    filterLabel: "Filter modules by sector",
    catalogLink: "See the Academy catalogue",
    objectives: "Objectives",
    audience: "Audience",
    duration: "Duration",
    format: "Format",
    level: "Level",
    standard: "Standard",
    formats: { onsite: "On site", remote: "Remote", hybrid: "Hybrid" },
    levels: { beginner: "Introductory", intermediate: "Intermediate", advanced: "Advanced" },
    request: "Request a session",
    none: "No module published for this sector yet.",
    quoteNote: "Programme, dates and quote confirmed within 48h of your request.",
    form: {
      title: "Request a session",
      company: "Company",
      contact: "Contact name",
      email: "Business e-mail",
      phone: "Phone",
      site: "Country / site",
      participants: "Number of participants",
      dates: "Preferred dates",
      datesPh: "e.g. week of 12 January, or Q1 2027",
      format: "Preferred format",
      message: "Message (optional)",
      submit: "Send request",
      sending: "Sending…",
      success: (ref) => `Request ${ref} sent. A confirmation e-mail is on its way; the Academy team will contact you within 48h.`,
      participantsErr: "Between 1 and 500 participants.",
      tooMany: "Too many requests sent. Try again in an hour.",
      prefilled: "Form prefilled from your company profile.",
      close: "Close",
    },
    mine: "My session requests (Academy)",
    mineEmpty: "No session request yet.",
    statuses: { new: "New", in_progress: "In progress", scheduled: "Scheduled", done: "Completed", cancelled: "Cancelled" },
    h: { ref: "Ref.", date: "Date", module: "Module", participants: "Participants", dates: "Preferred dates", format: "Format", status: "Status", company: "Company", contact: "Contact", emails: "E-mails" },
    admin: {
      tab: "Academy",
      modules: "Catalogue modules",
      requests: "Session requests",
      add: "New module",
      edit: "Edit",
      save: "Save module",
      cancel: "Cancel",
      del: "Delete",
      confirmDel: (n) => `Delete the module “${n}”? A safety backup is created before deletion.`,
      published: "Published",
      up: "Move up",
      down: "Move down",
      vertical: "Sector",
      titleFr: "Title FR", titleEn: "Title EN", descFr: "Description FR", descEn: "Description EN",
      objFr: "Objectives FR (one per line)", objEn: "Objectives EN (one per line)",
      audFr: "Audience FR", audEn: "Audience EN", durFr: "Duration FR", durEn: "Duration EN",
      saved: "Module saved.",
      empty: "No module.",
      requestsEmpty: "No session request.",
      csv: "Export requests (CSV)",
    },
  },
  matchFilter: {
    label: "Verified experts only",
    hidden: (n) => `${n} unverified result(s) hidden`,
    show: "Show",
  },
  backup: {
    tab: "Backup",
    title: "Data backup",
    desc: "Updates and redeployments never delete your data: startup erases nothing, initial data is created only once and schema changes only add fields. On top of that, export your data at any time.",
    exportAll: "Export everything (JSON ZIP)",
    csvClients: "Clients (CSV)",
    csvExperts: "Experts (CSV)",
    createNow: "Create a backup now",
    created: "Backup created.",
    failed: "Backup failed.",
    storedTitle: "Stored backups",
    storedDesc: "An automatic backup is created every week (last 8 kept). A safety backup is also created before every deletion (expert, example experts, test data).",
    none: "No stored backup yet — the first weekly backup is created automatically a few minutes after startup.",
    h: { date: "Date", kind: "Type", size: "Size", content: "Content", where: "Storage", dl: "Download" },
    kinds: { weekly: "Weekly", manual: "Manual", "pre-delete": "Before deletion" },
    where: { object: "Object storage", db: "Database" },
    docs: "documents",
    download: "Download",
  },
  approval: {
    h: "Status",
    status: { pending: "Pending", approved: "Approved", rejected: "Rejected" },
    all: "All",
    filterLabel: "Filter experts by status",
    approve: "Approve",
    reject: "Reject",
    reasonPrompt: (n) => `Reason for rejecting ${n} (optional, sent to the expert by e-mail):`,
    pendingLower: "pending",
    badge: (n) => `${n} profile(s) awaiting approval`,
    reason: "Reason:",
    desc: {
      pending: "Your profile is being reviewed by the IndusHub team. It does not appear in matching results yet.",
      approved: "Your profile is approved: it appears in matching results and you can receive missions.",
      rejected: "Your profile was not accepted. Update and save it to submit it for review again.",
    },
  },
  report: {
    title: "Weekly e-mail report",
    desc: "Sent every Monday at 8:00 (Paris time): visits and unique visitors (vs previous week), top 3 pages, new requests, new experts, completed interventions and total invoiced excl. VAT.",
    enabled: "Automatic sending enabled",
    recipient: "Recipient",
    save: "Save",
    preview: "Send a preview now",
    previewNote: "The preview covers the last 7 days and goes to the saved recipient.",
    previewSent: (e) => `Preview sent to ${e}.`,
    previewFailed: "Sending the preview failed.",
    last: "Last automatic send:",
    never: "No automatic send yet.",
    runStatus: { sent: "sent", failed: "failed", sending: "in progress", retrying: "retry scheduled", abandoned: "abandoned", cancelled: "cancelled" },
  },
  waFab: {
    label: (n) => `Message us on WhatsApp (${n})`,
    message: "Hello IndusHub Afrique, I would like information about your services.",
  },
  adminX: {
    tabs: { partners: "Partners", settings: "Content & settings", whatsapp: "WhatsApp log" },
    assign: "Assign an expert",
    assignPh: "Choose an expert…",
    reassign: "Reassign",
    preferred: "preferred",
    confirmation: "Client receipt",
    emailStatus: { pending: "pending", sent: "sent", failed: "failed", skipped_no_recipient: "skipped", skipped_rate_limited: "rate-limited" },
    waOn: "Brevo WhatsApp configured.",
    waOff: (m) => `Brevo WhatsApp incomplete (missing: ${m}) — sends are skipped and logged as “skipped”.`,
    partnerName: "Name",
    partnerLink: "Link (https://…)",
    partnerOrder: "Order",
    partnerLogo: "Logo (PNG, JPG, WEBP, SVG — 2 MB max)",
    addPartner: "Add partner",
    save: "Save",
    upload: "Upload logo",
    uploading: "Uploading…",
    noLogo: "No logo",
    partnersEmpty: "No partners: the homepage shows the default elegant placeholders.",
    confirmDelPartner: (n) => `Delete partner ${n}?`,
    figuresTitle: "Key figures (homepage)",
    figuresDesc: "Leave empty to keep the default figures. “Live counter” shows the number of experts in the database.",
    valueFr: "Value FR", valueEn: "Value EN", labelFr: "Label FR", labelEn: "Label EN", live: "Live counter",
    addFigure: "Add a figure",
    remove: "Remove",
    saveFigures: "Save figures",
    resetFigures: "Reset to defaults",
    notifTitle: "Admin WhatsApp notifications",
    adminWa: "Admin WhatsApp number (international format)",
    saveNotif: "Save number",
    waH: { date: "Date", event: "Event", ref: "Ref.", role: "Recipient", number: "Number", status: "Status", detail: "Detail" },
    events: { urgent_request: "Urgent request", intervention_assigned: "Assignment", intervention_started: "Start", intervention_finished: "Closure" },
    roles: { client: "Client", expert: "Expert", admin: "Admin" },
    waStatus: { sent: "sent", failed: "failed", skipped: "skipped" },
  },
};

export const extra = { fr, en };
